export default "__VITE_ASSET__Bu5C_bC1__"